import 'blueimp-load-image';
import './registrationpoint/RegistrationPoint';